import apolloWrapper from '@hoc/apolloWrapper';
import { logger } from '@utils/logger';

import { Banner } from '../../Components/Banner/Banner';

import { useGetMainBannerQuery } from './queries/graphql.v3.generated';

export const MainBannerContainer: React.FC = () => {
  const { loading, data, error } = useGetMainBannerQuery({
    context: { batch: true },
  });

  if (loading) {
    return null;
  }

  if (error) {
    logger.error(error);
    return null;
  }

  if (!data) {
    logger.error('Empty render');
    return null;
  }

  return <Banner slides={data.mainBanner.slides} />;
};

export default apolloWrapper(MainBannerContainer);
